module.exports = __webpack_public_path__ + "img/synergy.40b2f01c.png";